import { Item } from "@enos-monorepo/lib/types/FoodManagementTypes";
import axios from "axios";

import { withFoodControlPointInstance } from "./foodControlPointService";

export const addItem = withFoodControlPointInstance<Item>();

export const updateItem = withFoodControlPointInstance<Item>(true);

export async function getAllItems() {
  return axios.get(`/Items/getallitems`).then((res) =>
    res.data.map(
      (
        item: Item & {
          registratedUser: string;
          foodControlPointInstanceId: string;
        },
      ) => ({
        ...item,
        foodControlPointInstanceId: item.foodControlPointInstanceId,
        registeredBy: item.registratedUser,
      }),
    ),
  ) as Promise<Item[]>;
}

export async function getItemByInstanceId(id: string) {
  return axios.get(`/Items/getitembyinstanceid`, { params: { id } }).then(
    (res) =>
      ({
        ...res.data,
        registeredBy: res.data.registratedUser,
        controlPointInstanceId: res.data.foodControlPointInstanceId,
      }) as Item,
  );
}
